import React, { useEffect, useState } from 'react'; //import React Component
import { NavLink } from 'react-router-dom';
import { Footer } from '../components/Footer';
import { Navigation } from '../components/Navigation';
import { cloudStore } from '../firebase';
import { collection, getDocs, query, where } from 'firebase/firestore';

export function Login() {
    //(Function: Collect Data)Collect data from input, set by ID
    const [phone, setphone] = useState("");
    const [password, setPassword] = useState("");
    const handleInputChange = (e) => {
        const { id, value } = e.target;
        if (id === "phone") {
            setphone(value);
        }
        if (id === "password") {
            setPassword(value);
        }
    }
    //(Function: Collect Data)-------------------------------------------
    const [userData, setuserData] = useState("")
    const [click, setclick] = useState(0)
    useEffect(() => {
        getDocs(query(collection(cloudStore, "userData"), where("Personal_Information.phone", "==", phone)))
            .then((querySnapshot) => {
                const userData = querySnapshot.docs.map((doc) => doc.data());
                setuserData(userData)
            });
    }, [click, phone])
    //(Function: LogIn) Click to log_in, set data in auth

    const log_in = async () => {
        let clickvalue = click
        setclick(clickvalue + 1)
        let tips = document.getElementById("snackbar");
        let text = "";

        if (password.trim().length === 0 || phone.trim().length === 0) {
            text = document.createTextNode("请输入全部信息.");
            tips.appendChild(text)
            tips.className = "show";
            setTimeout(() => {
                tips.className = tips.className.replace("show", "disappearFade");
                setTimeout(() => {
                    tips.innerHTML = '';
                }, 300);
            }, 2000);
        } else {
            console.log(phone.trim().length)
            if (phone.trim().length === 10) {
                if (userData.length === 0) {
                    text = document.createTextNode("改手机号不存在");
                    tips.appendChild(text)
                    tips.className = "show";
                    setTimeout(() => {
                        tips.className = tips.className.replace("show", "disappearFade");
                        setTimeout(() => {
                            tips.innerHTML = '';
                        }, 300);
                    }, 2000);
                } else {
                    let password_check = userData[0]["Personal_Information"]["password"]
                    let userID = userData[0]["Personal_Information"]["userID"]
                    let name = userData[0]["Personal_Information"]["name"]
                    if (password !== password_check) {
                        text = document.createTextNode("错误的密码请重试");
                        tips.appendChild(text)
                        tips.className = "show";
                        setTimeout(() => {
                            tips.className = tips.className.replace("show", "disappearFade");
                            setTimeout(() => {
                                tips.innerHTML = '';
                            }, 300);
                        }, 2000);
                    } else {
                        if (userData[0].officer === true) {
                            localStorage.setItem("这个是二级保证", true)
                        }
                        localStorage.setItem("currentLoginUser", name)
                        localStorage.setItem("currentLoginUserID", userID)
                        text = document.createTextNode("成功登录，现在跳转到主页");
                        tips.style.color = "red"
                        tips.appendChild(text)
                        tips.className = "show";
                        setTimeout(() => {
                            tips.className = tips.className.replace("show", "disappearFade");
                            setTimeout(() => {
                                tips.innerHTML = '';
                            }, 300);
                        }, 2000);
                        setTimeout(() => {
                            if (window.location.pathname === "/login") {
                                window.location.href = "/main";
                            }
                        }, 2500);
                    }
                }
            } else {
                text = document.createTextNode("错误的手机号请重试");
                tips.appendChild(text)
                tips.className = "show";
                setTimeout(() => {
                    tips.className = tips.className.replace("show", "disappearFade");
                    setTimeout(() => {
                        tips.innerHTML = '';
                    }, 300);
                }, 2000);
            }
        }
    }
    //(Function: LogIn)-----------------------------------------------------------------------------------------------------------------

    return (
        <div id="login_page">
            <Navigation />
            <main>
                <div className="login">
                    <div className="login_content">
                        <div className="area">
                            <ul className="circles">
                                <li></li>
                                <li></li>
                                <li></li>
                                <li></li>
                                <li></li>
                                <li></li>
                                <li></li>
                                <li></li>
                                <li></li>
                                <li></li>
                            </ul>
                        </div>
                        <h1 className="login_title">Login</h1>
                        <form>
                            {/* <label htmlFor="name">姓名: </label>
                            <input
                                type="text"
                                id="name"
                                placeholder="请填写注册姓名"
                                onChange={(e) => handleInputChange(e)}
                                value={name}
                            />
                            <br /> */}
                            <label htmlFor="ID">手机号: </label>
                            {/* <p style={{ fontSize: "25px", margin: "10px 0 0 0", color: "#c94b34" }}>格式: +1 XXXXXXXXXX</p> */}
                            <input
                                id="phone"
                                type="text"
                                placeholder="请填写注册手机号"
                                onChange={(e) => handleInputChange(e)}
                                value={phone}
                            />
                            <br />
                            <label htmlFor="Password">密码: </label>
                            <input
                                type="text"
                                id="password"
                                placeholder="请填写注册密码"
                                onChange={(e) => handleInputChange(e)}
                                value={password}
                            />
                            <div className="button submit" onClick={log_in}>提交</div>
                        </form>
                        <div className="create_account">
                            <NavLink to="/signup"><span>没有账号？</span></NavLink>
                        </div>
                        <div id="snackbar"></div>
                    </div>
                </div>
            </main>
            <Footer />
        </div>
    );
}